<template>
  <hello-world />
</template>

<script>
  import HelloWorld from '../components/Home.vue'

  export default {
    name: 'HomeComponet',

    components: {
      HelloWorld,
    },
  }
</script>
